var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifiOff = function SvgWifiOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "m8 8 80 80M34 66a20 20 0 0 1 28 0M8 35.28a60 60 0 0 1 16.68-10.6M42.64 20A59.94 59.94 0 0 1 88 35.04M67.4 45a40 40 0 0 1 8.88 6.72M20 52a40 40 0 0 1 20.96-11.04M48 80h.04"
  })));
};
export default SvgWifiOff;